const PATH = '/financials';

export default {
    async financialsForSymbol(symbol) {

        return axios.get(`${PATH}/${symbol}`);
    }
}
